import { ToolResult } from '../../types/tool.types';
import { SKY_TEXTURES } from '../../../core/constants/texture-options';

/**
 * Get available sky/environment texture options.
 * Returns a list of sky textures with their key, name, and description.
 */
export async function getSkyOptions(): Promise<ToolResult> {
	const options = SKY_TEXTURES.map((texture) => ({
		key: texture.key,
		name: texture.name,
		description: texture.description,
		thumbnail: texture.thumbnail ? `textures/${texture.thumbnail}` : undefined
	}));

	return {
		success: true,
		data: {
			options,
			currentDefault: 'sky/overcast',
			usage: 'Use set_sky_texture with any key to change the sky environment'
		}
	};
}
